import { Box, Typography } from '@mui/material'

interface EditorialMetaProps {
    lines: string[]
}

const EditorialMeta: React.FC<EditorialMetaProps> = ({ lines }) => {
    return (
        <Box sx={{ mb: 3, mt: 2 }}>
            {lines.map((line, index) => (
                <Typography
                    key={index}
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: 'block', fontStyle: 'italic', lineHeight: 1.8 }}
                >
                    {line}
                </Typography>
            ))}
        </Box>
    )
}

export default EditorialMeta
export type { EditorialMetaProps }
